const imageUrl = process.env.REACT_APP_API_BASE_URL;
export const ImageLink = (name) => {
  return `${imageUrl}${name}`;
};

export const formatDate = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).replace(/\b(am|pm)\b/gi, (match) => match.toUpperCase());;
};

export const truncateText = (text, limit = 100) => {
  if (!text) return "";
  return text.length > limit ? text.slice(0, limit) + "..." : text;
};

export const customStyles = {
  control: (provided, state) => ({
    ...provided,
    fontSize: "13px",
    minHeight: "45px",
    height: "45px",
    border: "1px solid black",
    boxShadow: "none",
    "&:hover": {
      border: "1px solid black",
    },
  }),

  valueContainer: (provided) => ({
    ...provided,
    height: "45px",
    padding: "0 10px",
  }),

  input: (provided) => ({
    ...provided,
    margin: "0px",
  }),

  indicatorsContainer: (provided) => ({
    ...provided,
    height: "45px",
  }),

  menu: (provided) => ({
    ...provided,
    fontSize: "13px",
  }),

  option: (provided) => ({
    ...provided,
    fontSize: "13px",
  }),

  singleValue: (provided) => ({
    ...provided,
    fontSize: "13px",
  }),
};